var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vrm-custom-widget-form__parameter__placeholder"},[_c('div',{class:{ 'sg-error': _vm.hasErrors }},[_vm._v(_vm._s(_vm.$t('custom_widgets.no_selected_devices')))]),_c('span',[_vm._v(_vm._s(_vm.$t('custom_widgets.please_add_parameter')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }